
import BASE_URL from "../Services/AxiosInstance"
export const API_ENDPOINTS = {
  
  //////////////////////////////////////USER URLS /////////////////////////////////////
  GET_USER_LIST: "/api/Users/getUserList",
  GET_USER_NAME:"/api/Users/getUserName",
//////////////////////////////////////PROJECT URLS /////////////////////////////////////

  GET_PROJECTS_REPORT: "/getProjectlisting",
  
  GET_PROJECTS_NAME: "api/Projects/getProjects",
  GET_PROJECTS_LOADING:"/getProjectsOnload",
  GET_PROJECTS_BYUSERID:"/api/Projects/GetProjectById",
  POST_PROJECTS:"/api/Projects/add",
GET_TASK_PROJECT:"/GetProject_TaskName",
GET_PROJECT_HISTORY:"/ProjectHistory",
UPDATE_PROJECT:"/api/Projects/UpdateProject",

//////////////////////////////////////TASK URLS /////////////////////////////////////
GET_TASKS_REPORT: "/api/Tasks/GetTaskReport",
  ADD_TASK: "/api/Tasks/AddTask",
  
  UPDATE_TASK:"/api/Tasks/updateTask",
  GET_TASKS_BY_USERID: "/GetTaskListById",
  GET_TASKS_BY_PROJECTID: "/GetTaskListById",
  GET_TASKS_BYID: "/GetTask_Id/",


  ///////////////////////////////////// status /////////////////////////////////////
  GET_STATUS: "/status",
  GET_PRIORIIY:"/priority",
  GET_ROLE:"/ROLE"
};